module.exports = __webpack_public_path__ + "static/media/PaidTick.1f1ddd9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ToolTip/PaidTick.png
// module id = 2384
// module chunks = 0